import { cx, slugify } from '@/utils/strings'

type Props = {
  handleOnClick: () => void
  tag: { label: string; value: string }
  selectedTag: string
  count?: number
}

export default function TagButton({ handleOnClick, tag, selectedTag, count }: Props) {
  return (
    <button
      type="button"
      className={cx(
        'capitalize text-left leading-tight font-medium border-2 border-secondary-50 rounded-md py-2 px-4 hover:bg-secondary-50 dark:hover:text-secondary-900',
        selectedTag === tag.value && 'bg-secondary-50 dark:text-secondary-900'
      )}
      onClick={() => {
        handleOnClick()
      }}
      key={slugify(tag.value)}
    >
      {tag.label} {count && <span className="text-xs text-secondary-500">({count})</span>}
    </button>
  )
}
